// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GXI8","label":"styles_label__V1fX2"};